export default __webpack_public_path__ + "static/media/amparo-material-4.ae767446.webp";